export const _en = {
    name: {
        label: "Name"
    },
    description: {
        label: "Description"
    },
    startTime: {
        label: "Start time"
    },
    finishTime: {
        label: "Finish time"
    }
};

export const _fr = {
    name: {
        label: "Nom"
    },
    description: {
        label: "Description"
    },
    startTime: {
        label: "Heure de début"
    },
    finishTime: {
        label: "Heure de fin"
    }
};